import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { timer } from 'rxjs';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ngx-fleet-operator-login',
  templateUrl: './fleet-operator-login.component.html',
  styleUrls: ['./fleet-operator-login.component.scss']
})
export class FleetOperatorLoginComponent {
  loginStatus: string | null = null;
  loginStatusMessage: string | null = null;

  loginForm = this.fb.group({
    email: [
      '',
      [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$')],
    ],
    password: ['', [Validators.required]],
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly http: HttpClient,
    private readonly router: Router
  ) {}

  login() {
    if (this.loginForm.valid) {
      this.http
        .post<any>(environment.API_ENDPOINT + 'module/fleet/auth/login', this.loginForm.value)
        .subscribe({
          next: (res) => {
            if (res.type === 'success') {
              localStorage.setItem('fleet_token', res.data.token);
              localStorage.setItem('FleetOperatorDetails', JSON.stringify(res.data.fleetOperator));
              this.loginStatus = res.type;
              this.loginStatusMessage = res.message;
              timer(1000).subscribe(() => {
                this.router.navigate(['/fleet-operator/dashboard']);
              });
            }
          },
          error: (error) => {
            this.loginStatus = error.error?.type || 'error';
            this.loginStatusMessage = error.error?.message || 'Login failed';
          },
        });
    }
  }
}
